module.exports = __webpack_public_path__ + "img/dgjg2335_2.8db43ef4.svg";